<template>
  <div class="hello">
    <h1>Exponential-ekvation </h1>

    <div class="body-stil">
<div class="uppgiftstext">
    <h3>Uppgift 2</h3>
    <p>En ny bil kostar 300000 kr. Värdet antas minska med 20% varje år.</p>
      <p><b>a)</b> Efter hur många år är bilen bara värd 60000 kr?</p>
      <p><b>b)</b> Efter hur många år är bilen helt värdelös enligt modellen<sup>*</sup>?<br> &nbsp;  &nbsp; &nbsp;<sup>*</sup>(d.v.s. antagandet att värdet minskar med 20 % årligen)</p>
      <img src="../assets/bil.jpg" alt="cool bil">

</div>

</div>





  </div>
</template>

<script>
export default {
    name: 'StartPage',
    props: {
        msg: String
    },
    created() {
        document.title = 'Exponentialekvation 2';
        const favicon = document.getElementById('favicon');
        favicon.href="../assets/bil.ico";

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.uppgiftstext {
    text-align: left;
    color: black;
    background-color: lightgreen;
    border: solid 1px;
    padding-left: 1em;
    border-radius: 5px;
}
.body-stil {
    margin-left:15%;
    margin-right:15%;
}
.tips1 {
    color:darkred;
}


.tips3 {
    color:darkgreen;
}

.tips4 {
    color:darkblue;
}

.tips {
    height: 4em;
    overflow-y: hidden;
}

.hello {
    min-height: calc(100vh - 70px);
}


.pil {
    cursor: context-menu;

    -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
}
.pil:hover {
    text-decoration: underline;
}
img {
    margin-bottom: 1em;
}
</style>
